const messages = {
  hello: 'hello'
}

export default messages
